import PropTypes from "prop-types";
import { Subtitle } from "components/atoms/Text";

const ArticleCard = ({ icons, title, description }) => {
    return (
        <div className="w-full phone:h-[325px] bg-neutral-10 phone:p-6 flex flex-col justify-between tablet:p-6 p-8 rounded-lg">
            <div>
                <div className="bg-primary-surface w-fit rounded-lg mb-8 p-[15px] flex items-center justify-center">
                    <img src={`/icons/articles/${icons}.svg`} className="w-[34px] h-[34px]" alt={icons} />
                </div>
                <h1 className="font-medium text-heading-4 phone:text-[24px] tablet:text-[24px] tablet:leading-[36px] phone:leading-[36px] text-neutral-100 pb-3">{title}</h1>
                <Subtitle>{description}</Subtitle>
            </div>
            <h3 className="font-semibold text-primary-main leading-[19.83px] flex items-center text-md phone:mt-0 mt-8 tracking-text-sm">
                See Articles
                <svg width="20" height="20" className="ml-3" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.0254 4.94165L17.0837 9.99998L12.0254 15.0583" stroke="#645AFF" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M2.91699 10H16.942" stroke="#645AFF" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </h3>
        </div>
    );
};

ArticleCard.propTypes = {
    icons: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
};

export default ArticleCard;